import { Button } from "reactstrap";
import { Rate } from "rsuite";
import ReviewCard from "../../Cards/ReviewCard";
import AppEmptyState from "../../../../elements/AppEmptyState";

interface Props {
  app: any;
}

const Reviews = ({ app }: Props) => {
  return (
    <div className="d-flex flex-column pl-2">
      {/* TOP RATING */}
      <div className="d-flex justify-content-between align-items-center py-5">
        <div className="d-flex" style={{ gap: 10 }}>
          <h1>{app.Rating}</h1>
          <div className="d-flex flex-column">
            <span className="" style={{ fontSize: 12 }}>
              Rating
            </span>
            <div className="d-flex align-items-center" style={{ gap: 10 }}>
              <Rate
                defaultValue={app.Rating ? app.Rating : 0}
                color="orange"
                size="xs"
                allowHalf
              />
              <span style={{ fontSize: 10 }}>
                ({app?.Reviews ? app.Reviews.length : 0} reviews)
              </span>
            </div>
          </div>
        </div>
        <Button>Write Review</Button>
      </div>
      {/* FILER */}
      <div>
        <Button className="d-flex">
          <i className="mdi mdi-swap-vertical" style={{ fontSize: 12 }} />
          <span style={{ fontSize: 12 }}>Rating</span>
          <i className="mdi mdi-chevron-down" style={{ fontSize: 12 }} />
        </Button>
      </div>
      {/* FILER */}
      <div className="d-flex flex-column mt-4" style={{ gap: 30 }}>
        {app?.Reviews?.length ? (
          app.Reviews.map((review: any) => {
            return <ReviewCard review={review} />;
          })
        ) : (
          <AppEmptyState
            title="No Reviews"
            description="There are no reviews."
          />
        )}
      </div>
    </div>
  );
};

export default Reviews;
